import flatpickr from 'flatpickr';
import addDays from 'date-fns/addDays';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';

import requestIdleCallback from '../helpers/requestIdleCallback';

import {withDwUtils} from './tosc5/dw-utils';

const TOSC5_LOCAL_STORAGE_ID = 'bsm'; // LocalStorageID: Üblicherweise der Linkkey.

const FORM_SELECTOR = '.js-bs-tosc5-form';

// see https://flatpickr.js.org/options/
const FLATPICKER_OPTIONS = {
	altInput: true,
	altFormat: document.documentElement.lang === 'en' ? 'd/m/Y' : 'd.m.Y',
	dateFormat: 'Ymd',
	minDate: 'today',
	//defaultDate: new Date().fp_incr(1),
};

const now = new Date();
const tomorrow = addDays(now, 1);

function ModifiedRangePlugin(config = {}) {
	return function (fp) {
		let dateFormat = '';
		let secondInput;
		let _secondInputFocused;

		let prevDates = fp.selectedDates;

		function handleValueUpdate(selDates) {
			if (!prevDates || selDates.length >= prevDates.length) {
				prevDates = [...selDates];
			}

			let newDates;
			const [newSelectedDate] = selDates;
			if (_secondInputFocused) {
				newDates = [prevDates[0], newSelectedDate];

				if (newSelectedDate <= prevDates[0]) {
					newDates[0] = addDays(
						newSelectedDate,
						-1 *
							differenceInCalendarDays(prevDates[1], prevDates[0])
					);
				}
			} else {
				newDates = [newSelectedDate, prevDates[1]];

				if (newSelectedDate >= prevDates[1]) {
					newDates[1] = addDays(
						newSelectedDate,
						differenceInCalendarDays(prevDates[1], prevDates[0])
					);
				}
			}

			if (newDates[0] < now) {
				newDates[0] = now;
			}

			if (newDates[1] < tomorrow) {
				newDates[1] = tomorrow;
			}

			fp.setDate(newDates, false);
			prevDates = [...newDates];
			fp._input.value = fp.formatDate(newDates[0], dateFormat) || '';
			secondInput.value = fp.formatDate(newDates[1], dateFormat) || '';
		}

		const createSecondInput = () => {
			secondInput = config.input;
			secondInput.setAttribute('data-fp-omit', '');

			fp._bind(secondInput, ['focus', 'click'], () => {
				if (fp.selectedDates[1]) {
					fp.latestSelectedDateObj = fp.selectedDates[1];
					fp._setHoursFromDate(fp.selectedDates[1]);
					fp.jumpToDate(fp.selectedDates[1]);
				}
				_secondInputFocused = true;
				fp.isOpen = false;
				fp.open(
					undefined,
					config.position === 'left' ? fp._input : secondInput
				);
			});
			fp._bind(fp._input, ['focus', 'click'], (e) => {
				e.preventDefault();
				fp.isOpen = false;
				fp.open();
			});

			fp._bind(secondInput, 'keydown', (e) => {
				if (e.key === 'Enter') {
					fp.setDate(
						[fp.selectedDates[0], secondInput.value],
						true,
						dateFormat
					);
					secondInput.click();
				}
			});
		};

		const plugin = {
			onParseConfig: function () {
				fp.config.mode = 'range';
				dateFormat = fp.config.altInput
					? fp.config.altFormat
					: fp.config.dateFormat;
			},

			onReady: function () {
				createSecondInput();
				fp.config.ignoredFocusElements.push(secondInput);
				fp._input.removeAttribute('readonly');
				secondInput.removeAttribute('readonly');
				fp._bind(fp._input, 'focus', () => {
					fp.latestSelectedDateObj = fp.selectedDates[0];
					fp._setHoursFromDate(fp.selectedDates[0]);
					_secondInputFocused = false;
					fp.jumpToDate(fp.selectedDates[0]);
				});
				fp._bind(fp._input, 'keydown', (e) => {
					if (e.key === 'Enter')
						fp.setDate(
							[fp._input.value, fp.selectedDates[1]],
							true,
							dateFormat
						);
				});
				fp.setDate(fp.selectedDates, false);
				plugin.onValueUpdate(fp.selectedDates);
				fp.loadedPlugins.push('range');
			},

			onPreCalendarPosition: function () {
				if (_secondInputFocused) {
					fp._positionElement = secondInput;
					setTimeout(() => {
						fp._positionElement = fp._input;
					}, 0);
				}
			},

			onChange: function () {
				if (!fp.selectedDates.length) {
					setTimeout(() => {
						if (fp.selectedDates.length) return;
						secondInput.value = '';
						prevDates = [];
					}, 10);
				}

				if (_secondInputFocused) {
					setTimeout(() => {
						secondInput.focus();
					}, 0);
				}
			},

			onValueUpdate: handleValueUpdate,
		};
		return plugin;
	};
}

function renderForm(formElement) {
	formElement.addEventListener('submit', handleSubmit);

	const arrElement = formElement.querySelector('[name="selArrivalDate"]');
	const depElement = formElement.querySelector('[name="selDepartureDate"]');
	const pepElement = formElement.querySelector(
		'[name="selAdultsSearchLine1"]'
	);

	const fp = flatpickr(arrElement, {
		mode: 'range',
		plugins: [new ModifiedRangePlugin({input: depElement})],
		defaultDate: [new Date(), new Date().fp_incr(1)],
		...FLATPICKER_OPTIONS,
		//defaultDate: new Date().fp_incr(3),
	});

	//flatpickr(depElement, {
	//	...FLATPICKER_OPTIONS,
	//	defaultDate: new Date().fp_incr(10),
	//});

	function handleSubmit(e) {
		e.preventDefault();

		const [from, to] = fp.selectedDates;

		const guestData = {
			dateFrom: from,
			dateTo: to,
			occupancy1: {
				adults: parseInt(pepElement.value, 10),
				units: 1,
				children: 0,
			},
		};

		const cb = () => {
			window.location.href = formElement.action;
		};

		withDwUtils(() => {
			dw.accommodationQuickFind(TOSC5_LOCAL_STORAGE_ID, guestData, cb);
		});
	}

	// lazy preload script when form is present
	requestIdleCallback(() => {
		withDwUtils();
	});
}

function initForms() {
	[...document.querySelectorAll(FORM_SELECTOR)].forEach(renderForm);
}

export function render() {
	initForms();
}
